import { Link } from "react-router-dom";
import { CreditCard, LayoutDashboard, PackageSearch, UserRound } from "lucide-react";
import { useSeo } from "../lib/seo";
import { useCart } from "../context/CartContext";
import { money } from "../lib/api";
import NotFoundBlock from "./NotFoundBlock";

const Phase = ({ icon: Icon, title, text, testid, children }) => (
  <section className="max-w-2xl mx-auto px-4 sm:px-6 py-20 text-center" data-testid={testid}>
    <span className="w-20 h-20 rounded-full sunset-gradient grid place-items-center mx-auto"><Icon className="w-9 h-9 text-white" /></span>
    <h1 className="mt-6 text-4xl font-extrabold text-navy">{title}</h1>
    <p className="mt-4 text-navy/70 text-lg">{text}</p>
    <p className="mt-6 inline-block rounded-full bg-sun/30 text-navy text-sm font-bold px-4 py-2">Coming in Phase 2</p>
    {children}
  </section>
);

export const Checkout = () => {
  const { count, subtotal } = useCart();
  useSeo({ title: "Checkout", noindex: true });
  return (
    <Phase icon={CreditCard} title="Secure checkout" text="Stripe Checkout (cards & digital wallets) with verified webhooks is being connected next. No payment is taken on this page yet." testid="checkout-page">
      <p className="mt-6 text-navy font-semibold" data-testid="checkout-summary">{count} item(s) · {money(subtotal)}</p>
      <Link to="/cart" className="inline-block mt-6 rounded-full bg-navy text-white px-8 py-3.5 font-bold">Back to cart</Link>
    </Phase>
  );
};

export const Account = () => {
  useSeo({ title: "My Account", noindex: true });
  return <Phase icon={UserRound} title="Your account" text="Sign in with email & password or Google, view orders, save favorites and manage addresses." testid="account-page" />;
};

export const TrackOrder = () => {
  useSeo({ title: "Track Your Order", description: "Track your Vacation Apparel order status and shipping." });
  return <Phase icon={PackageSearch} title="Track your order" text="Order tracking with live Printify production & shipping status will appear here once checkout launches." testid="track-order-page" />;
};

export const Admin = () => {
  useSeo({ title: "Admin", noindex: true });
  return <Phase icon={LayoutDashboard} title="Admin dashboard" text="Secure admin for products, destinations, Printify sync, orders, discounts, banners and analytics." testid="admin-page" />;
};

export const NotFound = () => {
  useSeo({ title: "Page not found", noindex: true });
  return <NotFoundBlock />;
};
